import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  standalone: false,
    selector: "formly-field-repeat-section",
    templateUrl: "./repeat-section.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldRepeatSection extends FieldArrayType  {
}